var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Deck"},_vm._l((_vm.cards),function(card,index){return _c('Card',{key:index,attrs:{"card":card,"initial-state":false}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }